import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { downloadTranscript, encodeCode, fmtNum, formatDateTime, usePortalExams } from "../../components/portalUtils";
import { ErrorBox, Loader } from "../../components/PortalBits";

const BADGE = {
  passed: ["pass", "Pass"],
  failed: ["fail", "Fail"],
  terminated: ["fail", "Ended"],
  "in-review": ["review", "In review"],
  "in-progress": ["neutral", "In progress"],
};

function ExamHistory() {
  const navigate = useNavigate();
  const { user } = useOutletContext() || {};
  const { loading, error, exams, reload } = usePortalExams();

  return (
    <div className="panel">
      <h2>Exam history</h2>
      <div className="sub">Your past exam attempts, scores, and transcripts across all certifications.</div>
      {loading && <Loader />}
      {!loading && error && <ErrorBox message={error} onRetry={() => reload()} />}
      {!loading && !error && exams.length === 0 && (
        <div className="empty-state">You haven't taken an exam yet. Open a certification from My exams to book a slot.</div>
      )}
      {!loading && !error && exams.length > 0 && (
        <div className="hx-grid">
          {exams.map((ex) => (
            <div key={ex.exam_code} className="hx-card">
              <div className="hx-top">
                <span className="hx-code">{ex.exam_code}</span>
                {ex.status_label && <span className="hx-pill">{ex.status_label}</span>}
              </div>

              <h3 className="hx-title">{ex.full_name}</h3>

              <div className="hx-meta">
                {ex.duration_minutes ? <span>⏱ {ex.duration_minutes} min</span> : null}
                {ex.questions ? <span>📝 {ex.questions} Qs</span> : null}
                {ex.passing_percentage != null ? <span>✓ {fmtNum(ex.passing_percentage)}% to pass</span> : null}
              </div>

              <div className="hx-attempts">
                {ex.attempts.length === 0 ? (
                  <div className="hx-attempt hx-empty">
                    <span className="hist-score" style={{ color: "var(--ink-faint)" }}>
                      No attempts yet —{" "}
                      <button type="button" className="cbook-link-btn" style={{ padding: 0 }} onClick={() => navigate(`/user-panel/dashboard/${encodeCode(ex.exam_code)}`)}>
                        book a slot from My exams
                      </button>{" "}
                      to get started.
                    </span>
                  </div>
                ) : (
                  ex.attempts
                    .slice()
                    .reverse()
                    .map((a) => {
                      const [cls, label] = BADGE[a.state] || BADGE["in-review"];
                      const r = a.result;
                      return (
                        <div key={a.attempt_id} className="hx-attempt">
                          <div className="hx-attempt-row">
                            <span className="hist-date">{formatDateTime(a.date) || a.slot_date || "—"}</span>
                            <span className={`status-badge ${cls}`} style={{ padding: "4px 12px", fontSize: 11 }}>{label}</span>
                          </div>
                          <div className="hx-attempt-row">
                            <span className="hist-score">
                              Attempt {a.attempt_number}
                              {r ? (
                                <> · <b>{fmtNum(r.score)}/{fmtNum(r.maximum_score)}</b> ({fmtNum(r.percentage)}%)</>
                              ) : a.state === "in-review" ? (
                                " · Result pending review"
                              ) : null}
                            </span>
                            <span className="hist-actions">
                              {a.state === "passed" && ex.transcript_enabled && (
                                <button type="button" className="btn btn-outline btn-sm" onClick={() => downloadTranscript({ user, exam: ex, attempt: a })}>
                                  Download transcript
                                </button>
                              )}
                            </span>
                          </div>
                        </div>
                      );
                    })
                )}
              </div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ExamHistory;